var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.352 3.79A6.5 6.5 0 0123.45 8.386a6.5 6.5 0 01-1.905 4.597l-8.838 8.839a1 1 0 01-1.415 0l-8.838-8.839a6.5 6.5 0 019.193-9.193l.352.353.353-.353zm4.597.095a4.5 4.5 0 00-3.182 1.319l-1.06 1.06a1 1 0 01-1.415 0l-1.06-1.06a4.5 4.5 0 00-6.364 6.365l8.131 8.131 8.132-8.131a4.5 4.5 0 00-3.182-7.684z",
    fill: "#000"
  })));
}
export default SvgHeart;